import { searchCollaborators, getCollaboratorsByIds } from "services/supabaseUsers";
import { searchProjects } from "services/supabaseProjects";
import { useAuth } from "./useAuth.jsx";
import { useCallback } from "react";

const useDistributorCollaboratorSearch = () => {
  const { user } = useAuth();

  const distSearchResults = useCallback(
    async (searchTerm) => {
      try {
        if (user == null) return [];
        const results = await searchProjects(user.uid, "", {}, "modifiedAt:desc", 1, 200);
        const distributorMap = new Map();
        for (const project of results.projects) {
          if (project.distributor && project.distributor !== "xxxx" && !distributorMap.has(project.distributor)) {
            distributorMap.set(project.distributor, project.accountNumber || "");
          }
        }

        const entries = [...distributorMap.entries()];
        const filtered = searchTerm
          ? entries.filter(([dist]) =>
              dist.toLowerCase().includes(searchTerm.toLowerCase())
            )
          : entries;

        return filtered.map(([distributor, accountNumber]) => ({
          value: { distributor, accountNumber },
          label: distributor,
        }));
      } catch (error) {
        console.error("Distributor search failed:", error);
        return [];
      }
    },
    [user],
  );

  const distRepSearchResults = useCallback(
    async (searchTerm) => {
      try {
        if (user == null) return [];
        const results = await searchProjects(user.uid, "", {}, "modifiedAt:desc", 1, 200);
        const uniqueReps = [...new Set(
          results.projects.map((p) => p.rep).filter(Boolean).filter((r) => r !== "xxxx")
        )];

        const filtered = searchTerm
          ? uniqueReps.filter((r) =>
              r.toLowerCase().includes(searchTerm.toLowerCase())
            )
          : uniqueReps;

        return filtered.map((result) => ({
          value: result,
          label: result,
        }));
      } catch (error) {
        console.error("Rep search failed:", error);
        return [];
      }
    },
    [user],
  );

  const collaboratorsSearchResults = useCallback(
    async (searchTerm, userID) => {
      try {
        const users = await searchCollaborators(searchTerm, userID);
        return users.map((result) => ({
          value: result.id,
          label: result.name,
        }));
      } catch (error) {
        console.error("Collaborator search failed:", error);
        return [];
      }
    },
    [],
  );

  const collaboratorsByIDs = useCallback(
    async (collaboratorIDs) => {
      return getCollaboratorsByIds(collaboratorIDs);
    },
    [],
  );

  return {
    distSearchResults,
    distRepSearchResults,
    collaboratorsSearchResults,
    collaboratorsByIDs,
  };
};

export default useDistributorCollaboratorSearch;
